// extracted by mini-css-extract-plugin
module.exports = {"nav":"Header_nav__KGCvH","menus":"Header_menus__9UBft","menu__item":"Header_menu__item__g7dUJ","menu__link":"Header_menu__link__202y6"};